import { LogicContext } from '../types';
import config from '../../../config';
import models from '../../../model';
import { getLocale } from '../../../utils';

export const fetchGameToLaunch = async (
  context: LogicContext,
  event: {
    payload: {
      presentationCode: string;
      sectionTitle?: string;
      elementType?: string;
      gamePosition?: number;
      gameList?: string;
      gameShuffleCount?: number;
    };
  }
) => {
  const data = await models.fetchGame({
    locale: getLocale(config),
    viewer_country: config.viewer_country,
    viewer_region: config.viewer_region,
    game_code: event.payload.presentationCode,
  });
  const basePath = config.base_path || '';

  if (data.result === 'failure') {
    if (data.error.status === 404) {
      return {
        path: `${basePath}${config.functionalities.gameLaunch.path}/${event.payload.presentationCode}`,
      };
    }

    throw new Error('System error');
  }

  const fetchedGame = {
    ...data.game,
    gameDetailsPath: `${basePath}${data.game.gameDetailsPath}`,
    gameLaunchPath: `${basePath}${data.game.gameLaunchPath}`,
    ...(event.payload.gameShuffleCount
      ? { gameShuffleCount: event.payload.gameShuffleCount }
      : null),
  };
  if (event.payload.sectionTitle)
    fetchedGame.sectionTitle = event.payload.sectionTitle;
  if (event.payload.elementType)
    fetchedGame.elementType = event.payload.elementType;
  if (event.payload.gamePosition)
    fetchedGame.gamePosition = event.payload.gamePosition;
  if (event.payload.gameList) fetchedGame.gameList = event.payload.gameList;

  return {
    game: fetchedGame,
  };
};
